import React from 'react'

const DetailPlaceholderV2 = () => {
  return (
    <div className="detail-page-layout-template">
      <div className="detail-page-layout-template__top detail-placeholder__top" />
      <div className="detail-page-layout-template__content">
        <div className="detail-page-layout-template__center">
          <div className="detail-content-layout-template">
            <div className="detail-content-layout-template__left detail-placeholder__left">
              <div className="detail-placeholder__actions">
                <div>
                  <div className="detail-placeholder__actions--rounded" />
                </div>
                <div className="detail-placeholder__actions--text" />
              </div>
              <div className="detail-placeholder__actions">
                <div>
                  <div className="detail-placeholder__actions--rounded" />
                </div>
                <div className="detail-placeholder__actions--text" />
              </div>
              <div className="detail-placeholder__actions">
                <div>
                  <div className="detail-placeholder__actions--rounded" />
                </div>
                <div className="detail-placeholder__actions--text" />
              </div>
              <div className="detail-placeholder__actions">
                <div>
                  <div className="detail-placeholder__actions--rounded" />
                </div>
                <div className="detail-placeholder__actions--text" />
              </div>
            </div>
            <div className="detail-content-layout-template__right detail-placeholder__right">
              <div className="detail-content-layout-template__right-item detail-placeholder__content" />
              <div className="detail-content-layout-template__right-item detail-placeholder__content" />
              <div className="detail-content-layout-template__right-item detail-placeholder__content" />
              <div className="detail-content-layout-template__right-item detail-placeholder__content" />
              <div className="detail-content-layout-template__right-item detail-placeholder__content" />
              <div className="detail-content-layout-template__right-item detail-placeholder__content detail-placeholder__content--short" />
            </div>
          </div>
        </div>
        <div className="detail-page-layout-template__right detail-placeholder__marketplace" />
      </div>
      <div className="detail-page-layout-template__bottom" />
    </div>
  )
}

export default DetailPlaceholderV2
